export const userRoles = {
  OWNER: "Владелец",
  ADMIN: "Администратор",
  EDITOR: "Редактор",
  COMMENTER: "Комментатор",
  VIEWER: "Зритель",
};

export const Colors = {
  commonPurple: "#9A6AFF",
};
